import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { getLeaderboard, updateCohost } from 'components/graphql/queries'
import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';
import { Card } from 'reactstrap';

const Leaderboard: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const ADDITIONAL_LINK = '-additional-link-'

    const [campaignId] = useState(props.campaignId)
    const [createdBy] = useState(props.createdBy)
    const [loading, setLoading] = useState(true)
    const [leaderboard, setLeaderboard] = useState<any[]>([])
    const [updateKey, setUpdateKey] = useState(Math.random())

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: getLeaderboard,
                variables: {
                    campaignId,
                    createdBy
                }
            })
            .then(res => {
                setLoading(false)
                const lead: any[] = []
                const leadObject: any = {}
                res.data.data.order.getLeaderboardItems.map((item: any) => {
                    if (!item.name.includes(ADDITIONAL_LINK)) {
                        leadObject[item.name] = {
                            sellerId: item.sellerId,
                            name: item.name,
                            isHost: item.isHost,
                            sold: item.sold,
                            addedBy: item.addedBy,
                            isPaymentSetup: item.isPaymentSetup
                        }
                    }
                })
                res.data.data.order.getLeaderboardItems.map((item: any) => {
                    if (item.name.includes(ADDITIONAL_LINK)) {
                        if (leadObject[item.name.split(ADDITIONAL_LINK)[0]]) {
                            leadObject[item.name.split(ADDITIONAL_LINK)[0]] = {
                                ...leadObject[item.name.split(ADDITIONAL_LINK)[0]],
                                sold: (leadObject[item.name.split(ADDITIONAL_LINK)[0]].sold + item.sold)
                            }
                        } else {
                            leadObject[item.name.split(ADDITIONAL_LINK)[0]] = {
                                sellerId: item.sellerId,
                                name: item.name.split(ADDITIONAL_LINK)[0],
                                isHost: item.isHost,
                                sold: item.sold,
                                addedBy: item.addedBy,
                                isPaymentSetup: item.isPaymentSetup
                            }
                        }
                    }
                })
                Object.keys(leadObject).map((key: any) => {
                    lead.push(leadObject[key])
                })
                lead.sort((a, b) => {
                    return b.sold - a.sold
                })
                setLeaderboard(lead)
            })
            .catch(err => {
                console.log(err)
            })
    }, [setLoading, campaignId, props.user, setLeaderboard, createdBy, updateKey])

    const handleHostChange = useCallback((userId, value) => {
        fetchAPI.post(API_ENDPOINTS.BASE_URL, {
            query: updateCohost,
            variables: {
                userId,
                isHost: Boolean(value),
                campaignId
            }
        }).then(res => {
            if (res.data && res.data.data.cohost.updateCohost) {
                setUpdateKey(Math.random())
            }
        })
    }, [campaignId])

    if (loading) {
        return null;
    }

    return <div>
        <Card style={{ paddingTop: '15px', paddingBottom: '20px' }}>
            <br />
            <div style={{
                overflowX: "scroll", paddingTop: '10px', // maxHeight: '550px'
            }}>
                {
                    leaderboard.length > 0 ?
                        <table className='table-responsive--base m-0' style={{ width: '100%', textAlign: 'left', fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <td>AFFILIATE</td>
                                    <td>TICKETS SOLD</td>
                                    <td>ADDED BY</td>
                                    <td>HOST</td>
                                    <td>PAYOUT SET UP</td>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '13px' }}>
                                {
                                    leaderboard.map((item: any, index: number) => {
                                        if (campaignId === '5f90604c6ea452402a7ead4e' && item.name === 'thehalloweenmasquerave') {
                                            if (props.user.id !== '5d633fbe4105f5165db03b9a' && !props.user.isAdmin) {
                                                return null
                                            }
                                        }
                                        return <tr key={index}>
                                            <td style={{ fontWeight: item.sellerId === props.createdBy ? 'bold' : 'normal' }}>
                                                {
                                                    index === 0 && item.sold !== 0 ? <span>🥇</span> : ' '
                                                }
                                                {
                                                    index === 1 && item.sold !== 0 ? <span>🥈</span> : ' '
                                                }
                                                {
                                                    index === 2 && item.sold !== 0 ? <span>🥉</span> : ' '
                                                }
                                                {
                                                    item.name.includes(ADDITIONAL_LINK)
                                                        ? (item.name.split("-")[0] + " (link #" + (Number(item.name.split("-")[3]) + 2).toString() + ")")
                                                        : item.name
                                                }</td>
                                            <td>{item.sold}</td>
                                            <td>
                                                {item.addedBy}
                                            </td>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    disabled={item.sellerId === props.createdBy || (props.user.id !== props.createdBy && !props.user.isAdmin && !props.isHost)}
                                                    checked={item.sellerId === props.createdBy ? true : item.isHost}
                                                    onChange={e => handleHostChange(item.sellerId, !item.isHost)}
                                                    style={{ height: '10px', width: '10px' }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    disabled={true}
                                                    checked={item.isPaymentSetup}
                                                    onChange={e => {
                                                        // console.log()
                                                    }}
                                                    style={{ height: '10px', width: '10px' }}
                                                />
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                        :
                        <p style={{ width: '100%', textAlign: 'center' }}>
                            No team members
                        </p>
                }
            </div>
        </Card>
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(Leaderboard);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/Leaderboard.tsx